// ── localStorage persistence for GPS sessions ─────────────────────────────────
// This is a temporary client-side store until the backend endpoints are ready.
// Key: "vlf_gps_sessions"
// Value: JSON array of session objects.

// Import GPS da file: resta nascosto finché il backend non salva le sessioni,
// altrimenti i dati resterebbero solo nel browser di chi li importa
export const GPS_FILE_IMPORT = false;

const STORE_KEY = "vlf_gps_sessions";

const readStore = () => {
	try {
		return JSON.parse(localStorage.getItem(STORE_KEY) ?? "[]");
	} catch {
		return [];
	}
};

const writeStore = (sessions) => {
	localStorage.setItem(STORE_KEY, JSON.stringify(sessions));
};

export const getStoredSessions = () => readStore();

export const saveSession = (session) => {
	// session must have an `id` field (caller is responsible for generating it)
	const sessions = readStore();
	const idx = sessions.findIndex((s) => s.id === session.id);
	if (idx >= 0) {
		sessions[idx] = session;
	} else {
		sessions.unshift(session);
	}
	writeStore(sessions);
	return session;
};

export const getSessionById = (id) => {
	return readStore().find((s) => s.id === id) ?? null;
};

export const deleteSession = (id) => {
	const sessions = readStore().filter((s) => s.id !== id);
	writeStore(sessions);
};
